//
// Module for the Participant Communication's Contact Logs view
//
rs.module("content/participant/account/communications/contactlog",

    [
        "controls/data/grid"
    ],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, backendUrl) {

            // Unpack Js Selectors
            var filter = $.js(jsSelectors.filter);

            var reasonSelect = filter.js(jsSelectors.reasonSelect);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // Update the grid based on selected reason
            reasonSelect.change(function () {
                loadingSpinner.show();
                gridModule.update(
                    backendUrl,
                    { reason: this.value },
                    lrsGridApi.agGridApi,
                    function done(gridUpate) {
                        loadingSpinner.hide();
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);